var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10326_243512)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM10.401 5.1C8.51604 5.1 7.0025 6.61329 7.0025 8.49819C7.0025 10.3837 8.51598 11.8971 10.401 11.8971C12.2861 11.8971 13.7996 10.3837 13.7996 8.49819C13.7996 6.61329 12.286 5.1 10.401 5.1ZM8.81229 13.1079C6.98296 13.1079 5.5 14.5909 5.5 16.4202C5.5 17.3189 6.22859 18.0475 7.12735 18.0475H13.4889C14.3876 18.0475 15.1162 17.3189 15.1162 16.4202C15.1162 14.5909 13.6332 13.1079 11.8039 13.1079H8.81229ZM14.5802 10.5955C14.3758 10.9178 14.5093 11.3751 14.891 11.3751C16.617 11.3751 18.0027 9.98946 18.0027 8.26306C18.0027 6.53724 16.6169 5.15166 14.891 5.15166C14.3215 5.15166 14.2043 5.8556 14.5224 6.32799C14.9401 6.94834 15.1834 7.69717 15.1834 8.50571C15.1834 9.27646 14.9625 9.99289 14.5802 10.5955ZM17.9243 17.6509C17.1083 17.6509 16.4469 16.9894 16.4469 16.1735V15.5488C16.4469 14.8807 16.2082 14.2627 15.8032 13.7599C15.5996 13.5072 15.7648 13.0083 16.0894 13.0083C17.9187 13.0083 19.4016 14.4021 19.4016 16.1214V16.1735C19.4016 16.9894 18.7402 17.6509 17.9243 17.6509Z",
    fill: "url(#paint0_linear_10326_243512)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10326_243512",
    x1: 19.5,
    y1: 4.5,
    x2: 9,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB783"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10326_243512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityIcon);
export default __webpack_public_path__ + "static/media/community-icon.504094596ad92e510c940933e106b473.svg";
export { ForwardRef as ReactComponent };